import React, { useEffect, useState } from "react";
import { FaCreditCard, FaMoneyBillWave, FaPiggyBank } from "react-icons/fa";
import { fetchTaxa } from "../../integration/taxas/fetchTaxa";
import { formatToBRL } from "brazilian-values";

const TaxasDePagamento = () => {
  const [taxas, setTaxas] = useState({
    pixPercentage: null,
    pixFixed: null,
    pixReserve: null,
    withdrawalFixed: null,
    withdrawalPercentage: null
  });

  const funcTaxa = async () => {
    try {
      const resposta = await fetchTaxa();
      setTaxas(resposta);
    } catch (erro) {
      console.error("Erro ao buscar histórico de taxa:", erro);
    }
  };

  useEffect(() => {
    funcTaxa();
  }, []);

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg">
      <h2 className="text-2xl font-light text-[#0c0c0c] text-center mb-4">
        Taxas de Pagamento
      </h2>
      <p className="text-center text-sm text-gray-600 mb-6">
        Todas as taxas de forma clara.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {/* Card PIX */}
        <div className="bg-[#f7f7f7] p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-center space-x-3 mb-4">
            <FaPiggyBank size={24} className="text-[#baa78e]" />
            <h3 className="text-lg text-[#000]">Tarifa PIX</h3>
          </div>
          <p className="text-sm text-[#000]">
            Valor{" "}
            {taxas.pixFixed ? `  ${formatToBRL(taxas.pixFixed / 100)}` : "0"}
          </p>
          <p className="text-xs text-gray-600">
            Reserva {taxas.pixReserve ? `${taxas.pixReserve * 100}%` : "0"}
          </p>
        </div>

        {/* Card Cartão */}
        <div className="bg-[#f7f7f7] p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-center space-x-3 mb-4">
            <FaCreditCard size={24} className="text-[#baa78e]" />
            <h3 className="text-lg text-[#000]">Tarifa Cartão</h3>
          </div>
          <p className="text-sm text-[#000]">
            Valor{" "}
            {taxas.card_porcent
              ? `R$ ${taxas.card_porcent * 100}`
              : "Não disponível"}
          </p>
          <p className="text-xs text-gray-600">
            Reserva{" "}
            {taxas.card_reserv
              ? `${taxas.card_reserv * 100}%`
              : "Não disponível"}
          </p>
        </div>

        {/* Card Saque */}
        <div className="bg-[#f7f7f7] p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow col-span-1 sm:col-span-2">
          <div className="flex items-center space-x-3 mb-4">
            <FaMoneyBillWave size={24} className="text-[#baa78e]" />
            <h3 className="text-lg text-[#000]">Tarifa Saque</h3>
          </div>
          <p className="text-sm text-[#000]">
            Valor{" "}
            {taxas.withdrawalFixed
              ? `${formatToBRL(taxas.withdrawalFixed / 100)}`
              : "Não disponível"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TaxasDePagamento;
